module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "film-festival__item"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06308430","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/exclusive-to-sk/film-festivals/film-festival-list-item.vue
// module id = 776
// module chunks = 0